import React from 'react'
import {useCallback, useEffect, useRef, useState} from 'react'
import FormTitleVideo from './formTitleVideo/FormTitleVideo';
import ComponentUploadImgToS3 from '../../../../../uploadToS3/ComponentUploadImgToS3';
import ComponentUploadVideoToS3 from '../../../../../uploadToS3/ComponentUploadVideoToS3';

export default function FormNewVideo(props) {
  
    const [formState, setFormState] = useState({
          url: '',
          thumbnail:'',
          description: '',
          title:'',
          document:'',
          
      });
      const [uploadState, setUploadState] = useState({
        isVideoUploading: false,
      });
      const modalContentRef = useRef(null);
      const handleVideoUploadStatusChange = useCallback((isUploading) => {
        setUploadState((prevState) => (
          prevState.isVideoUploading === isUploading
            ? prevState
            : {
                ...prevState,
                isVideoUploading: isUploading,
              }
        ));
      }, []);
      const setUrl =()=>{
        setFormState({url:'', thumbnail:''})
       }

      useEffect(() => {
        const modalElement = modalContentRef.current?.closest('.modal');
        if (!modalElement) {
          return undefined;
        }

        const handleModalHide = () => {
          const activeEl = document.activeElement;
          if (activeEl && modalElement.contains(activeEl) && typeof activeEl.blur === 'function') {
            activeEl.blur();
          }
        };

        modalElement.addEventListener('hide.bs.modal', handleModalHide);

        return () => {
          modalElement.removeEventListener('hide.bs.modal', handleModalHide);
        };
      }, []);
    
    return (
            <div className="modal-content" ref={modalContentRef}>
              <div className="modal-header  d-flex justify-content-between">
                <h5 className="modal-title" id="newVideoModalModalLabel">
                  Tải lên học liệu/bài giảng mới của bạn
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Đóng"
                  onClick={(event) => {
                    event.currentTarget.blur();
                    setFormState({
                      url: '',
                      thumbnail:'',
                      description: '',
                      title:'',
                      document:'',
                    });
                  }}
                  data-bs-dismiss="modal"
                ></button>
              </div>
              <div className="modal-body">    
                  <div className="form-group">
                    <label className="col-form-label">
                      <b>Chọn ảnh đại diện của học liệu</b>
                    </label>
                    <ComponentUploadImgToS3 formListVideo={formState} setFormListVideo={setFormState}></ComponentUploadImgToS3>
                    <label className="col-form-label">
                      <b>Tải lên video </b>
                      </label>
                    {/* <div className='mx-auto'></div> */}
                    {/* <div> {<Link to="/feedback" ><span data-bs-dismiss="modal">tìm hiểu về tốc độ bit</span></Link>}</div> */}
                   <ComponentUploadVideoToS3
                    formState={formState}
                    setFormState={setFormState}
                    onUploadStatusChange={handleVideoUploadStatusChange}
                   ></ComponentUploadVideoToS3>
                   
                  </div>
                  <FormTitleVideo 
                    urlVideo={formState.url} 
                    thumbnail={formState.thumbnail} 
                    videoListId={props.videoListId}
                    setUrl ={setUrl}
                    isVideoUploading={uploadState.isVideoUploading}
                    >
                  </FormTitleVideo>
              </div>
            </div>
          
    )
}
